var React = require('react');

function MinusSign (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M20 2H0V0h20z"}));
}

MinusSign.defaultProps = {"width":"20","height":"2","fill":"none"};

module.exports = MinusSign;

MinusSign.default = MinusSign;
